import React, { useState, useEffect } from 'react'
import dayjs from 'dayjs'

import Button from '../button'
import Checkbox from '../checkbox'
import { useLanguage } from 'assets/languages'

interface Props {
  closeModal: () => void
  onConfirm?: () => void
  title: string
  mainText: string
  showDailyHideCheckbox?: boolean
  checkboxText?: string
  buttonText?: string
  storageKey?: string  
}

const ModalType1 = (props: Props) => {
  const language = useLanguage()
  const languageTexts = {
    ...language.common,
    ...language.database.rental_posting_due,
    ...language.component.modelCard,
  }
  
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false)
  // ✅ Use storageKey directly instead of building it
  const storageKey = props.storageKey || 'modal_hidden_until_default'

  useEffect(() => {
    if (props.showDailyHideCheckbox) {
      const hiddenUntil = localStorage.getItem(storageKey)
      if (hiddenUntil && dayjs().isBefore(dayjs(hiddenUntil))) {
        setIsCheckboxChecked(true)
      }
    }
  }, [storageKey, props.showDailyHideCheckbox])

  const handleConfirm = () => {
    if (props.showDailyHideCheckbox && isCheckboxChecked) {
      localStorage.setItem(storageKey, dayjs().add(1, 'day').toISOString())
    }
    props.onConfirm?.()
    props.closeModal()
  }

  return (
    <div className="p-[30px] max-w-[360px] bg-white">
      <div className="flex flex-col gap-[5px]">
        <span className="font-bold">{props.title}</span>
        <span className="whitespace-pre-wrap">{props.mainText}</span>
      </div>

      {props.showDailyHideCheckbox && (
        <div className="mt-[10px]">
          <Checkbox
            text={props.checkboxText || languageTexts?.dont_show_today}
            checked={isCheckboxChecked}
            onClick={(isChecked) => {
              setIsCheckboxChecked(isChecked)
            }}
          />
        </div>
      )}

      <div className="mt-[20px] w-full">
        <Button
          text={props.buttonText || languageTexts?.confirm}
          buttonColor="#000"
          textColor="#fff"
          onClick={handleConfirm}
        />
      </div>
    </div>
  )
}

export default ModalType1
